import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-crossfire',
  templateUrl: './ramadan20-crossfire.component.html',
  styleUrls: ['./ramadan20-crossfire.component.css']
})
export class Ramadan20CrossfireComponent implements OnInit {


  gameName = "crossfire";

  constructor() { }

  ngOnInit() {
  }

}
